module.exports = __webpack_public_path__ + "img/google-icon.6dfbba2e.svg";